<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card>
        <div>
          <b-row>
            <b-col cols="12" xl="4">
              <Categories :categoryId="categoryId"/>
            </b-col>
            <b-col cols="12" xl="8" >
              <Products :page="page" :categoryId="categoryId"/>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import statuses from '@/store/statuses';
import { mapActions, mapGetters } from 'vuex';
import VuexTypes from '@/store/types/index';
import forEach from 'lodash.foreach';
import Categories from './Categories/Categories';
import Products from './Products/Products';

const ProcurementSchemeTypes = VuexTypes.procurementScheme;
export default {
  mounted() {
    this.getData();
  },
  props: ['categoryId', 'page'],
  data() {
    return {
      spinners: {
        contentIsLoading: true,
      },
    };
  },
  components: { Categories, Products },
  computed: {
    ...mapGetters('ProcurementScheme', [

    ]),
  },
  watch: {

  },
  methods: {
    ...mapActions('ProcurementScheme', [

    ]),
    getData() {

    },
    fillData() {

    },

    onUpdate() {

    }
  }
};

</script>

<style>
</style>
